const isSafeExamBrowser = (): boolean => {
  const userAgent = window.navigator.userAgent
  const regex = /SEB/i
  return regex.test(userAgent)
}

export default isSafeExamBrowser
